'use client';
import { useUpdatePostReaction } from '@/actions/feed.actions';
import useConnectModalStore from '@/components/store/connectModalSlice';
import useJoinNonProfitDialogStore from '@/components/store/joinNonProfitDialogSlice';
import OrgType from '@/constants/orgType.constant';
import { ProfileTypes, TargetViewers } from '@/constants/profileType.constant';
import useHasUserSession from '@/hooks/useHasUserSession';
import useUserProfile from '@/hooks/useUserProfile';
import Button from '@ui/Button';
import Typography from '@ui/Typography';
import {
  getPostPageDescription,
  getPostPageTitle,
} from '@utils/pageMeta.helper';
import { getPostLink } from '@utils/post.helper';
import { cx } from 'cva';
import { usePathname, useRouter } from 'next/navigation';
import React, { useEffect } from 'react';
import { HiHeart } from 'react-icons/hi';
import { MdChat } from 'react-icons/md';
import PostComments from './PostComments';
import ReactionButton from './ReactionButton';
import ShareButton from './ShareButton';
import useConfirmDialogStore from '../Dialogs/confirmDialog.store';
import { switchUserCommunity } from '@/actions/switch-community.action';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';
import useJoinCommunityDialogStore from '../store/joinCommunityDialogSlice';

function ActionBar(props) {
  const { post, className = '', orgSlug = null } = props;

  const { comment: canComment, react: canReact } = post.renderProps.permissions;
  const [showComments, setShowComments] = React.useState(
    canComment && post.totalComments > 0,
  );

  const hasUserSession = useHasUserSession();
  const user = useUserProfile();

  const router = useRouter();
  const pathname = usePathname();
  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);
  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );
  const { seekConfirmation } = useConfirmDialogStore();

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const setShowJoinCommunityModal = useJoinCommunityDialogStore(
    (state) => state.setOpen,
  );

  // mutations
  const { mutate: updateReaction } = useUpdatePostReaction();

  const postLink = getPostLink(post, orgSlug);

  let recordShareClickPayload = {
    type: 'post',
    postId: post.id,
    shareClick: {
      userId: user?.id,
      activeCommunityId: user?.activeCommunity?.id,
      location: user?.location,
    },
  };

  const handleGuestUserAction = async () => {
    if (hasUserSession) {
      if (!post.renderProps.isPromotionPost) {
        const { hasPermissionsForCommunity } = post.renderProps.permissions;

        if (hasPermissionsForCommunity) {
          const confirmed = await seekConfirmation(
            'Switch Community?',
            'You need to switch community to participate on this post.',
            'Yes, Go Ahead',
          );

          if (confirmed) {
            switchUserCommunity(hasPermissionsForCommunity.communityId);
          }
        } else {
          const companyId = post.renderProps.company?.id;
          const companySlug = post.renderProps.company?.slug;
          const nonProfitCompanyId = post.renderProps.nonProfit?.company_id;

          if (
            (pathname.startsWith('/nonprofit') && post.renderProps.nonProfit) ||
            companyId === nonProfitCompanyId
          ) {
            setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
            // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
            // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
            // router.replace(
            //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
            // );
            // setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
          } else if (companySlug && companySlug.includes('nonprofit/')) {
            setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
            // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
            // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
            // router.replace(
            //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
            // );
            // setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
          } else if (companySlug && companySlug.includes('company/')) {
            setShowConnectModal(true, post.renderProps.company);
            // setShowCompanyConnectPopUp(true, post.renderProps.company);
          } else {
            setShowJoinCommunityModal(true, post.renderProps.company);
          }
        }
      }
    } else {
      const companyId = post.renderProps.company?.id;
      const companySlug = post.renderProps.company?.slug;
      const nonProfitCompanyId = post.renderProps.nonProfit?.company_id;

      if (
        (pathname.startsWith('/nonprofit') && post.renderProps.nonProfit) ||
        companyId === nonProfitCompanyId
      ) {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      } else if (companySlug && companySlug.includes('nonprofit/')) {
        // setShowJoinNonProfitModal(true, post.renderProps.nonProfit);
        // setShowJoinNonProfitModal(false, post.renderProps.nonProfit);
        // const returnPath = `/onboard/nonprofit-user?nonProfitId=${post.renderProps.nonProfit?.id}`;
        // router.replace(
        //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
        // );
        setShowNonProfitSignUpPopUp(true, post.renderProps.nonProfit);
      } else {
        // setShowConnectModal(true, post.renderProps.company);
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      }
    }
  };

  const handleCommentClick = () => {
    if (!post.renderProps.isPromotionPost) {
      if (canComment) {
        setShowComments(!showComments);
      } else {
        handleGuestUserAction();
      }
    }
  };

  const handleReaction = (reaction) => {
    updateReaction({ postId: post.id, reaction });
  };

  return (
    <div className={cx('flex w-full flex-col gap-2', className)}>
      <div className="flex items-center justify-between">
        {canReact ? (
          <ReactionButton
            userReaction={post.userReaction}
            onChange={handleReaction}
          />
        ) : (
          <Button
            variant="plain"
            onClick={handleGuestUserAction}
            disabled={post.renderProps.isPromotionPost}>
            <div className="flex items-center justify-center gap-4">
              <HiHeart className="text-text-secondary" />
              <Typography variant="h6">Like</Typography>
            </div>
          </Button>
        )}

        <Button
          variant="plain"
          onClick={handleCommentClick}
          disabled={post.renderProps.isPromotionPost}>
          <div className="flex items-center justify-center gap-4">
            <MdChat className="text-text-secondary" />
            <Typography variant="h6">Comment</Typography>
          </div>
        </Button>

        <ShareButton
          variant="iconText"
          url={postLink}
          title={`${getPostPageTitle(post)} | Neki`}
          description={getPostPageDescription(post)}
          recordPayload={recordShareClickPayload}
          disabled={
            post.renderProps.isPromotionPost ||
            post?.targetViewers !== TargetViewers.All
          }
        />
      </div>

      {showComments && <PostComments post={post} />}
    </div>
  );
}

export default ActionBar;
